export function getNewbuildingChatSrc(realtyUserId: number, defaultMessage: string) {
  return (
    `/dialogs/?hostType=frame&agentId=${realtyUserId}` +
    `&defaultMessage=${encodeURIComponent(defaultMessage)}` +
    '&noDefaultMsgIfChatExists=1' +
    '&pageType=Listing'
  );
}
